import React, { useCallback, useState } from "react";
import hash from "object-hash";

export const AssistantContext = React.createContext({});

export const AssistantContextProvider = (props) => {
  const [cacheInternal, setCacheInternal] = useState({});

  const getCache = useCallback(
    (context) => {
      const key = hash(context);
      return cacheInternal[key];
    },
    [cacheInternal]
  );

  const setCache = useCallback((context, items) => {
    const key = hash(context);

    setCacheInternal((prev) => ({
      ...prev,
      [key]: items,
    }));
  }, []);

  const updateCache = useCallback(
    (context, index) => {
      const key = hash(context);
      const items = cacheInternal[key];

      if (items) {
        setCacheInternal((prev) => ({
          ...prev,
          [key]: prev[key].filter((_, i) => i !== index),
        }));
      }
    },
    [cacheInternal]
  );

  return (
    <AssistantContext.Provider
      value={{
        getCache,
        setCache,
        updateCache,
      }}
    >
      {props.children}
    </AssistantContext.Provider>
  );
};
